import IconButton from "@material-ui/core/esm/IconButton";
import ExpandMore from "@material-ui/icons/esm/ExpandMore";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './ButtonStyles';
import LinkButton from './LinkButton';
export default function ExpandButton({
  onClick,
  isExpanded,
  children
}) {
  const {
    expand,
    expandOpen
  } = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkButton, {
    onClick: onClick
  }, children || t('buttons.see_more_details')), /*#__PURE__*/React.createElement(IconButton, {
    tabIndex: "-1",
    onClick: onClick,
    "aria-expanded": isExpanded,
    "aria-label": "show more",
    className: clsx(expand, isExpanded && expandOpen)
  }, /*#__PURE__*/React.createElement(ExpandMore, null)));
}